<!-- 404 NotFound页面 -->
<template>
    <div class="admin-error">
        <el-row class="admin-error-content">
            <el-col :span="14">
                <svg class="error-img">
                    <use xlink:href="#404"></use>
                </svg>
            </el-col>
            <el-col :span="10">
                <h5 class="error-code">404</h5>
                <p class="error-message">抱歉，你访问的页面不存在或仍在开发中</p>
                <div>
                    <el-button type="primary" @click="goToIndex()">返回首页</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import '@/assets/svg/404.svg';
import './error.scss';

export default {
    name: 'NotFound',

    data() {
        return {};
    },

    methods: {
        goToIndex() {
            this.$router.push({
                name: 'Forward',
                params: {
                    target: 'Index'
                }
            });
        }
    }
};
</script>
<style lang='scss'>
</style>
